<template>
  <v-card>
    <v-card-title class="headline">
      <span>
        Delete selected Approved Bill Lines?
        <span class="grey--text subheading"></span>
      </span>
    </v-card-title>
    <v-card-text>This action will affect {{ selectedCount }} line(s) </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1" flat @click="close()">Cancel</v-btn>

      <v-btn color="red" flat @click="deleteApprovedBillLines()" :loading="loading">Delete Lines</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import ApprovedBillLineService from "@/services/requests/approvedBillLineService";
import Store from '@/store/computed/storeHelpers'
import BuildExportQuery from '@/modules/approvedBillLines/mixins/buildExportQuery'

export default {
  mixins: [BuildExportQuery],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    deleteApprovedBillLines() {
      this.loading = true;
      var payload = {}
      if (this.selectedAll) {
        payload = this.buildQuery()
        // payload.pagination = this.pagination
      } else {
        payload.ids = this.selected.map(subject => {
          return subject.id;
        });
      }
      console.log(payload);
      ApprovedBillLineService.deleteMultipleApprovedBillLines(payload)
        .then(result => {
          for (var deleted of result.data.result.deleted) {
            this.$store.commit("approvedBillLines/deleteFromArrayStateById", {
              prop: "approvedBillLines",
              id: deleted
            });
          }
          this.snack({
            text: result.data.message,
            color: "green"
          });
          this.loading = false;
          this.close();
        })
        .catch(err => {
            console.log(err);
          this.loading = false;
          this.snack({ text: err.response ? err.response.data.message : err.message, color: "red" });
        });
    }
  },
  props: {
    selected: Array,
    pagination: Object,
  },
  computed: {
    filterBy: Store.getSet({ store: 'approvedBillLines', prop: 'filterBy' }),
    filterCol: Store.getSet({ store: 'approvedBillLines', prop: 'filterCol' }),
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    billingStatus: Store.getSet({ store: 'shared', prop: 'billingStatus' }),
    showClosed: Store.getSet({ store: 'shared', prop: 'showClosed' }),
    projectId: Store.getSet({ store: 'shared', prop: 'projectId' }),
    siteId: Store.getSet({ store: 'shared', prop: 'siteId' }),
    selectedUserId: Store.getSet({ store: 'shared', prop: 'selectedUserId' }),
    dateRangeStart: Store.getSet({ store: 'shared', prop: 'dateRangeStart' }),
    dateRangeEnd: Store.getSet({ store: 'shared', prop: 'dateRangeEnd' }),
    selectedAll: Store.getSet({
      store: 'approvedBillLines',
      prop: 'selectedAll'
    }),
    selectedCount() {
      if (this.selectedAll) {
        return this.pagination.totalItems
      } else {
        return this.selected.length
      }
    },
  }
};
</script>